<template>
  <result-item-template :name="result.item.name" icon-glyph="LAKE">
    <template #metadata>
      <ys-text v-if="parent" type="metadata1" data-test="waterbody-text">
        {{ parent }}
      </ys-text>
      <ys-text type="metadata1" data-test="search-result-subtext">
        <span v-if="cityState" data-test="city-state">
          {{ cityState }}
        </span>
        <!-- Distance away from user -->
        <span v-if="formattedArea">
          <span v-if="cityState" class="divider">|</span>
          {{ formattedArea.result }} {{ formattedArea.unit }}
        </span>
      </ys-text>
    </template>
  </result-item-template>
</template>

<script setup lang="ts">
///// imports /////
import { computed } from 'vue'
import type { FishingRegion } from '@onxmaps/supergraph'
import '@onxmaps/yellowstone-ui/ys-text'

import resultItemTemplate from '@/components/search/result-items/result-item-template.vue'
import { formatAreaForDisplay } from '@/fish/lib/query/query-card-utils'
import { getCityState } from '@/lib/search/search-utils'
import { getRegionParent } from '@/lib/knowledge-graph/utils'
import type { SearchResultProps } from '@/services/search-service/types'

///// types /////
// Special SearchResultProps variant denoted as a FishingRegion result
interface RegionSearchResult extends SearchResultProps {
  about: FishingRegion
}

interface RegionItemProps {
  result: RegionSearchResult
}

///// props/emits /////
const { result } = defineProps<RegionItemProps>()

///// computed /////
const cityState = computed(() => getCityState(result))

const parent = computed(() => {
  const waterbodies = result.about.waterbodies
  if (!waterbodies || waterbodies.length === 0) {
    return null
  }
  const parentWater = getRegionParent(waterbodies)
  return parentWater?.name ?? null
})

const formattedArea = computed(() => {
  if (result.about?.area) {
    return formatAreaForDisplay(result.about.area, false)
  }
  return null
})
</script>

<style lang="scss" scoped>
.divider {
  padding: 0 var(--ys-spacing-25);
}

ys-text {
  display: block;
}
</style>
